export default __webpack_public_path__ + "static/media/J240_RoHS.037dcd4c.pdf";